import React from "react";
import { makeStyles } from "@mui/styles";
import { FontSize } from "src/const/font";

const useStyles = makeStyles((theme) => {
  return {
    styleDefault: {
      fontSize: FontSize.normal.p2,
      fontWeight: 700,
      color: theme.custom?.text.title,
      [theme.breakpoints.down("md")]: {
        fontSize: FontSize.normal.p4,
      },
    },
  };
});
interface PropsTextTitleI {
  style?: React.CSSProperties;
  children: string | any;
  className?: string;
}

const TextTitle = (props: PropsTextTitleI) => {
  const { style, children, className } = props;
  const classes = useStyles();
  //! Render
  return (
    <>
      <p
        className={`${classes.styleDefault} ${className}`}
        style={{ ...style }}
      >
        {children}
      </p>
    </>
  );
};
export default TextTitle;
